import {
  Condition,
  PreorderCondition,
  StopLossTakeProfitType,
} from '@interfaces'

export const getStopLossTakeProfitType = (
  conditionInfo: PreorderCondition | Condition,
): StopLossTakeProfitType => {
  return conditionInfo?.trailAmount > 0 || conditionInfo?.trailPercentage > 0
    ? StopLossTakeProfitType.TRAILING
    : StopLossTakeProfitType.FIXED
}
